<template>
    <div class="block w-10/12 py-5 mx-auto">
        <h1 class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-4xl sm:tracking-tight">{{ incident.subject }}</h1>
        
        <div class="mt-2">
            <div class="flex gap-1">
                <div class="flex-none rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500 dark:bg-gray-400 dark:text-gray-400 dark:ring-gray-400">
                    {{ $t('incident.scope') }} : {{ incident.scope.name }}
                </div>
                <div class="flex-none rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500 dark:bg-gray-400 dark:text-gray-400 dark:ring-gray-400">
                    {{ $t('incident.severity') }} : {{ incident.severity.name }}
                </div>
                <div class="flex-none rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500 dark:bg-gray-400 dark:text-gray-400 dark:ring-gray-400">
                    {{ $t('incident.state') }} : {{ incident.state.name }}
                </div>
            </div>

            <div class="mt-5">
                <div v-html="incident.body"></div>
            </div>
        </div>

        <div class="mt-8">
            <h3 class="text-xl font-medium text-gray-900">{{ $t('incidentUpdates') }}</h3>
            <div class="mt-2">
                <ul role="list" class="space-y-6">
                    <li class="relative flex gap-x-4" v-for="update in updates" :key="update.id">
                        <div class="absolute -bottom-6 left-0 top-1.5 flex w-4 justify-center">
                            <div class="w-px bg-gray-400 dark:bg-white/15"></div>
                        </div>

                        <div class="relative flex flex-none w-4 h-4 top-1 items-center justify-center bg-gray-100 dark:bg-gray-900">
                            <div class="w-2 h-2 rounded-full bg-gray-500 ring ring-gray-600 dark:bg-white/10 dark:ring-white/20"></div>
                        </div>

                        <div class="text-xs/5 text-gray-900 dark:text-gray-400" v-html="update.body"></div>

                        <time :datetime="$d(update.created_at, 'longNumb')" class="flex-none py-0.5 text-sm text-gray-500 dark:text-gray-400">{{ $d(update.created_at, 'longNumb') }}</time>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { ArrowRightIcon } from "@heroicons/vue/outline";
import EmptyState from "../components/EmptyState.vue";

export default {
    name: "IncidentDetail",
    components: {
        ArrowRightIcon,
        EmptyState,
    },
    data() {
        return {
            incident: {},
            updates: [],
            id: this.$route.params.id,
        }
    },
    created() {
        this.getIncident();
    },
    methods: {
        async getIncident() {
            this.$emit("setLoading", true);
            try {
                const res = await axios.get(`${this.$cookie.getCookie("API")}/api/v1/incidents/${this.id}`);

                const parser = new DOMParser();
                this.incident = res.data;
                this.updates = res.data.updates.map(update => ({
                    ...update,
                    body: parser.parseFromString(update.body, 'text/html').body.innerHTML.replaceAll('&nbsp;', '').replaceAll('<br>', '')
                }));
            } catch (error) {
                this.errorHandling(error);
            } finally {
                this.$emit("setLoading", false);
            }
        }
    }
}
</script>